import script from "./TopMessageBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopMessageBanner.vue?vue&type=script&setup=true&lang=ts"

import "./TopMessageBanner.vue?vue&type=style&index=0&id=783304cf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-783304cf"]])

export default __exports__